import { render, staticRenderFns } from "./ChatTools.vue?vue&type=template&id=45f4d9fb&"
import script from "./ChatTools.vue?vue&type=script&lang=js&"
export * from "./ChatTools.vue?vue&type=script&lang=js&"
import style0 from "./ChatTools.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports